import { IState } from '../..';
import { IAction } from '../root/i-action';
import { IDevice } from './i-devices';
import { parseData } from '../../../utils/create-dataParser';

export const getDevicesListRequest = (state: IState): IState => ({
  ...state,
  devices: {
    data: [],
    loading: true,
    error: undefined,
    loaded: false,
  },
});

export const getDevicesListSuccess = (state: IState, action: IAction<IDevice[]>): IState => {
  const data = parseData(action.payload);
  return ({
    ...state,
    devices: {
      data,
      loading: false,
      error: undefined,
      loaded: true,
    },
  });
};

export const getDevicesListFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  devices: {
    data: [],
    loading: false,
    error: action.payload,
    loaded: false,
  },
});
